// extracted by mini-css-extract-plugin
module.exports = {"recaptcha":"captcha_recaptcha__3DpNq"};